"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._FitsignForm = exports._FitsignFormEditable = void 0;
exports._FitsignFormEditable = {
    guardianIBAN: {
        label: 'IBAN',
        uid: 'crmRequest.bankAccount.iban',
        required: true,
        type: 'iban',
    },
    guardianAccountHolder: {
        label: 'Account Holder',
        uid: 'crmRequest.bankAccount.accountHolder',
        required: true,
        type: 'text',
    },
};
exports._FitsignForm = __assign({ guardianGivenName: {
        uid: 'guardian.givenName',
        required: true,
        disabled: true,
        type: 'text',
    }, customerGivenName: {
        uid: 'crmRequest.givenName',
        required: true,
        disabled: true,
        type: 'text',
    }, customerFamilyName: {
        uid: 'crmRequest.familyName',
        required: true,
        disabled: true,
        type: 'text',
    }, guardianFamilyName: {
        uid: 'guardian.familyName',
        required: true,
        disabled: true,
        type: 'text',
    }, guardianPhone: {
        uid: 'guardian.phone',
        required: true,
        disabled: true,
        type: 'text',
    } }, exports._FitsignFormEditable);
